module.exports = __webpack_public_path__ + "c8112bcc3adb322866fe5e50b02e2685.png";